<ng-container [ngSwitch]="toolType$ | async">
  <mg-st-root *ngSwitchCase="'student'"></mg-st-root>
  <mg-st-root *ngSwitchCase="'parent'"></mg-st-root>
  <mg-at-root *ngSwitchCase="'admin'"></mg-at-root>
  <mg-tt-root *ngSwitchCase="'teacher'"></mg-tt-root>
</ng-container>
